/*
  Sertifikalar. Yeni bir tane eklemek icin asagiya bir kayit yaz.

  "credential" alanina sertifikanin dogrulama adresini koy (Coursera'da
  sertifika sayfasindaki "Verify" linki). Bos birakilirsa kart link
  yerine sade bir kutu olarak basilir.
*/

const certifications = [
  {
    id: "google-advanced-data-analytics",
    title: "Advanced Data Analytics",
    issuer: "Google",
    year: "2025",
    skills: ["Python", "Statistics", "Regression", "Machine Learning"],
    credential: "",
  },
];

export default certifications;
